import { Button, Fade, Grid, Tab, Tabs, Paper } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Product from 'classes/Product';
import PermissionHide from 'components/PermissionHide';
import Spin from 'components/Spin';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { loadProduct } from 'store/Orbita/Product/actions';
import Tour from 'v2/components/Shared/Tour';

import CampaignForm from './components/CampaignForm';
import CampaignTable from './components/CampaignTable';
import SalesPageUrls from './components/CampaignTable/SalesPageUrls';
import CheckoutBooster from './components/CheckoutBooster';
import CheckoutUrlsNew from './components/CheckoutUrlsNew';
import PostbackModal from './components/PostbackModal';
import QuickView from './components/QuickView';
import TrackerForm from './components/TrackerForm';
import UrlCreator from './components/UrlCreator';
import Filter from './Filter';
import styles from './styles';
import { campaignsListTourSteps, campaignsButtonsTourSteps } from './tour';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

enum tabType {
  EDUZZ,
  MYLINKS,
  PRODUCER,
  AFFILIATE,
  NONE,
}

export interface ICheckoutsUrls {
  linkSun: string;
  linkChk: string;
}

interface IProps extends DispatchProp<any>, RouteComponentProps<any>, StyledComponentProps {
  listProductsIsFetching: boolean;
  listCampaigns: any;
  listProducts: Array<Product>;
  loadingProduct: boolean;
  currentProduct: Product;
}

interface IStates {
  activeQuickView: boolean;
  activeUrlCreator: boolean;
  activeCampaignForm: boolean;
  activePostbackForm: boolean;
  activeTrackerForm: boolean;
  activeBooster: boolean;
  showTables: boolean;
  campaignQuick: any;
  campaignUrlCreator: string;
  campaignUrlCheckoutCreator: string;
  currentTab: number;
  openTour: boolean;
  selectedProductId: number;
}

class MyCampaigns extends Component<IProps, IStates> {
  updateListCampaigns: any;

  constructor(props: any) {
    super(props);
    this.state = {
      currentTab: tabType.NONE,
      activeQuickView: false,
      activeUrlCreator: false,
      activeCampaignForm: false,
      activePostbackForm: false,
      activeBooster: false,
      activeTrackerForm: false,
      showTables: false,
      campaignQuick: {},
      campaignUrlCreator: '',
      campaignUrlCheckoutCreator: '',
      openTour: false,
      selectedProductId: 0,
    };
  }

  handleChange = (event: any, currentTab: number) => {
    this.setState({ currentTab });
  };

  handleActiveQuick = () => {
    this.setState({ campaignQuick: {}, activeQuickView: false });
  };

  handleActiveUrlCreator = () => {
    this.setState({ campaignUrlCreator: '', activeUrlCreator: false });
    this.setState({ campaignUrlCheckoutCreator: '', activeUrlCreator: false });
  };

  handleChangeSelect = (product: number) => {
    if (product) {
      (async () => {
        try {
          this.setState({ selectedProductId: product });
          await this.props.dispatch(loadProduct(product, true));
          const prod = this.props.currentProduct;
          if (prod && prod.id) {
            this.setState({ showTables: true, currentTab: tabType.EDUZZ, openTour: false });
          } else {
            toast.error('Ocorreu um erro ao tentar carregar o produto');
            this.setState({ showTables: false });
          }
        } catch (error) {
          toast.error('Ops, erro ao carregar o produto');
        }
      })();
    } else {
      this.setState({ showTables: false, selectedProductId: null });
    }
  };

  openTrackerForm = () => {
    this.setState({ activeTrackerForm: true });
  };

  closeTrackerForm = () => {
    this.setState({ activeTrackerForm: false });
  };

  openUrlCreator = (campaign: string) => {
    this.setState({ campaignUrlCreator: campaign, activeUrlCreator: true });
  };

  openUrlCreatorCheckout = (urls: ICheckoutsUrls) => {
    this.setState({ campaignUrlCreator: urls.linkSun, campaignUrlCheckoutCreator: urls.linkChk, activeUrlCreator: true });
  };

  openQuickView = (campaign: any) => {
    this.setState({ campaignQuick: campaign, activeQuickView: true });
  };

  openCampaignForm = () => {
    this.setState({ activeCampaignForm: true });
  };

  openModalPostback = () => {
    this.setState({ activePostbackForm: true });
  };

  closeModalPostback = () => {
    this.setState({ activePostbackForm: false });
  };

  openModalBooster = () => {
    this.setState({ activeBooster: true });
  };

  closeModalBooster = () => {
    this.setState({ activeBooster: false });
  };

  handleActiveCampaignForm = () => {
    this.setState({ activeCampaignForm: false });
  };

  setUpdateListCampaigns = (updateFunction: any) => {
    this.updateListCampaigns = updateFunction;
  };

  componentDidMount() {
    let params = this.props.match.params;
    if (params && params.productId) {
      this.setState({ selectedProductId: params.productId });
      this.setState({ openTour: true });
    }
  }

  render() {
    const params = this.props.match.params;
    const { classes, currentProduct, loadingProduct } = this.props;
    const { currentTab, selectedProductId, activeTrackerForm } = this.state;
    const currentUserId = parseInt(localStorage.getItem('id'));
    const physicalProductPending = Boolean(currentProduct && currentProduct.type === 3 && currentProduct.moderation_status === 'P');
    const disabledCreateCampaign =
      currentProduct &&
      !currentProduct.is_producer &&
      (!currentProduct.affiliation_status || currentProduct.affiliation_status === 'R' || currentProduct.affiliation_status === 'P');

    return (
      <Fade in={true} timeout={500}>
        <>
          <div className='my-title' style={{ display: 'table' }}>
            <h1 style={{ width: '100%' }}>Meus Links de Divulgação</h1>
            <p style={{ width: '100%', margin: 0 }}>Links de Checkout, Funis e Campanhas para vender este produto/serviço.</p>
          </div>
          {!params.productId && !selectedProductId && <Tour name='campaigns_list_tour' steps={campaignsListTourSteps} />}
          {!params.productId && selectedProductId && <Tour name='campaigns_buttons_tour' steps={campaignsButtonsTourSteps} />}
          <div className='m32'></div>
          <div id='table__campaigns'>
            <Paper elevation={1} className={classes.paper}>
              <Grid container className={classes.inputsContainer}>
                <Grid id='myProductSelect' item xs={12} md={5}>
                  <Filter product={params.productId} onChange={this.handleChangeSelect} />
                  {selectedProductId > 0 && !loadingProduct && currentProduct && currentProduct.moderation_status === 'R' && (
                    <div className={`${classes.statusAlert} disapproved`}>* Este produto está reprovado.</div>
                  )}
                  {selectedProductId > 0 && !loadingProduct && currentProduct && currentProduct.affiliation_status === 'P' && (
                    <div className={`${classes.statusAlert} pending`}>* Sua afiliação ainda está pendente, você não será comissionado.</div>
                  )}
                  {selectedProductId > 0 && !loadingProduct && currentProduct && currentProduct.affiliation_status === 'R' && (
                    <div className={`${classes.statusAlert} disapproved`}>* Você não será comissionado, pois sua afiliação está reprovada.</div>
                  )}
                </Grid>
                <>
                  <Grid className={classes.buttonContainer}>
                    <PermissionHide action='myeduzz:links:editar'>
                      <Button
                        id='myUrlCreator'
                        color='primary'
                        disabled={!this.state.showTables}
                        onClick={this.openModalPostback}
                        className={classes.buttonPostback}
                        fullWidth
                      >
                        <span className={classes.buttonText}>URL Postback</span>
                      </Button>
                    </PermissionHide>
                  </Grid>
                  <Grid className={classes.buttonContainer}>
                    <PermissionHide action='myeduzz:links:criar'>
                      <Button
                        id='myNewCampaign'
                        color='primary'
                        disabled={!this.state.showTables || disabledCreateCampaign}
                        className={classes.buttonNew}
                        onClick={this.openCampaignForm}
                        fullWidth
                      >
                        <span className={classes.buttonText}>Criar Campanha</span>
                      </Button>
                    </PermissionHide>
                  </Grid>
                </>
              </Grid>
            </Paper>
          </div>
          <div className='m32'></div>

          {loadingProduct && <Spin />}

          {!loadingProduct && this.state.showTables && (
            <div>
              <Tabs
                value={currentTab}
                onChange={this.handleChange}
                indicatorColor='primary'
                textColor='primary'
                scrollButtons='off'
                classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                style={{ marginBottom: 16 }}
              >
                <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} value={0} label='Eduzz' />
                {currentProduct && !currentProduct.is_producer && (
                  <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} value={1} label='Meus Links' />
                )}
                <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} value={2} label='Produtor' />
                <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} value={3} label='Afiliado' />
              </Tabs>

              {currentTab === tabType.EDUZZ && (
                <Grid>
                  <CheckoutUrlsNew
                    openTrackerForm={this.openTrackerForm}
                    currentProduct={currentProduct}
                    currentUserId={currentUserId}
                    physicalProductPending={physicalProductPending}
                    openUrlCreatorCheckout={this.openUrlCreatorCheckout}
                  />

                  <Grid>
                    <SalesPageUrls currentProduct={currentProduct} currentUserId={currentUserId} physicalProductPending={physicalProductPending} />
                  </Grid>

                  {activeTrackerForm && (
                    <TrackerForm
                      open={activeTrackerForm}
                      handleClose={this.closeTrackerForm}
                      product={{ id: currentProduct.id }}
                      campaign={{ id: -1 }}
                    />
                  )}
                </Grid>
              )}

              {!currentProduct.is_producer && (
                <React.Fragment>
                  {currentTab === tabType.MYLINKS && (
                    <CampaignTable
                      type='my-links'
                      openUrlCreator={this.openUrlCreator}
                      openQuickView={this.openQuickView}
                      setUpdate={this.setUpdateListCampaigns}
                      isProducer={false}
                      openUrlCreatorCheckout={this.openUrlCreatorCheckout}
                    />
                  )}

                  {currentTab === tabType.PRODUCER && (
                    <CampaignTable
                      type='producer'
                      openUrlCreator={this.openUrlCreator}
                      openUrlCreatorCheckout={this.openUrlCreatorCheckout}
                      openQuickView={this.openQuickView}
                      setUpdate={this.setUpdateListCampaigns}
                      isProducer={false}
                    />
                  )}

                  {currentTab === tabType.AFFILIATE && (
                    <CampaignTable
                      type='affiliate'
                      openUrlCreator={this.openUrlCreator}
                      openUrlCreatorCheckout={this.openUrlCreatorCheckout}
                      setUpdate={this.setUpdateListCampaigns}
                      isProducer={false}
                    />
                  )}
                </React.Fragment>
              )}

              {currentProduct.is_producer && (
                <React.Fragment>
                  {currentTab === tabType.PRODUCER && (
                    <CampaignTable
                      type='producer'
                      openUrlCreator={this.openUrlCreator}
                      openUrlCreatorCheckout={this.openUrlCreatorCheckout}
                      openQuickView={this.openQuickView}
                      setUpdate={this.setUpdateListCampaigns}
                      isProducer={true}
                    />
                  )}

                  {currentTab === tabType.AFFILIATE && (
                    <CampaignTable
                      type='affiliate'
                      openUrlCreator={this.openUrlCreator}
                      openUrlCreatorCheckout={this.openUrlCreatorCheckout}
                      setUpdate={this.setUpdateListCampaigns}
                      isProducer={true}
                    />
                  )}
                </React.Fragment>
              )}
            </div>
          )}

          <QuickView
            active={this.state.activeQuickView}
            changeActive={this.handleActiveQuick}
            product={currentProduct}
            campaign={this.state.campaignQuick}
            updateListCampaigns={this.updateListCampaigns}
          />

          {this.state.activeUrlCreator && (
            <UrlCreator
              open={this.state.activeUrlCreator}
              handleClose={this.handleActiveUrlCreator}
              baseUrl={this.state.campaignUrlCreator}
              baseUrlChk={this.state.campaignUrlCheckoutCreator}
              isProducer={currentProduct.is_producer}
            />
          )}

          {this.state.activeCampaignForm && (
            <CampaignForm
              open={this.state.activeCampaignForm}
              handleClose={this.handleActiveCampaignForm}
              product={currentProduct}
              producer={currentProduct && currentProduct.is_producer}
              onChangeTab={this.handleChange}
              tabActive={this.state.currentTab}
              updateListCampaigns={this.updateListCampaigns}
            />
          )}

          {this.state.activePostbackForm && (
            <PostbackModal open={this.state.activePostbackForm} product={currentProduct} onClose={this.closeModalPostback} />
          )}

          {this.state.activeBooster && <CheckoutBooster open={this.state.activeBooster} product={currentProduct} onClose={this.closeModalBooster} />}
        </>
      </Fade>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    listProductsIsFetching: state.orbita.Product.listProductsCampaignFilter.isFetching,
    listProducts: state.orbita.Product.listProductsCampaignFilter,
    listCampaigns: state.orbita.Product.listProductCampaigns,
    currentProduct: new Product(state.orbita.Product.product),
    loadingProduct: state.orbita.Product.product.isFetching,
  };
}

export default styles(connect(mapStateToProps)(MyCampaigns)) as any;
